export function groupSegmentsByDirection<
  T extends { direction: string | number },
>(segments: T[]): Record<string, T[]> {
  return segments.reduce(
    (acc, segment) => {
      const direction = segment.direction
      if (!acc[direction]) {
        acc[direction] = []
      }
      acc[direction].push(segment)
      return acc
    },
    {} as Record<string, T[]>,
  )
}
